import { readable, derived } from 'svelte/store';
import Auth from 'firebase-auth-lite';
import { Database } from 'firebase-firestore-lite';
import Reference from 'firebase-storage-lite';

import config from './firebase.config';

export const auth = new Auth({
    apiKey: config.apiKey,
    redirectUri: `${window.location.origin}/auth`,
});

export const db = new Database({
    projectId: config.projectId,
    auth
});

export const storage = new Reference(config.storageBucket, auth);

export const authState = readable(null, set => auth.listen(set));

export const isAdmin = derived(authState, $authState => {
    return $authState &&
        $authState.customAttributes && 
        JSON.parse($authState.customAttributes).admin;
});

export default {
    auth,
    authState,
    isAdmin,
    db,
    storage
};
